import { CLEAN_REDUCER } from '../../constants/actionTypes';
import { LOG_OUT } from '../auth/actionTypes';
import { ADD_FUEL_BILL_SUCCESS, EDIT_FUEL_BILL_SUCCESS, FETCH_FUEL_BILLS } from './actionTypes';

const initState = {
	list: [],
	count: 0,
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case FETCH_FUEL_BILLS:
			return {
				...state,
				list: action.payload.data,
				count: action.payload.count,
			};
		case ADD_FUEL_BILL_SUCCESS:
			return {
				...state,
				list: [action.payload, ...state.list],
				count: state.count + 1,
			};
		case EDIT_FUEL_BILL_SUCCESS: {
			let edit = state.list.map((element) => {
				if (element.id !== action.payload.id) {
					return {
						...element,
					};
				}
				return {
					...element,
					...action.payload,
				};
			});
			return {
				...state,
				list: edit,
			};
		}
		case CLEAN_REDUCER:
		case LOG_OUT:
			return initState;
		default:
			return state;
	}
};

export default reducer;
